import { Button } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  /* spare space */
  margin-bottom: 10px;
`;
